import getReduxSelector from 'modules/redux/selectors/get'
import { GIFT_KEY, GIFT_PATH } from 'modules/gift/redux/constants'

const shouldDeliverToRecipientGiftSelect = state => {
  const path = GIFT_PATH[GIFT_KEY.SHOULD_DELIVER_TO_RECIPIENT]
  return getReduxSelector(path)(state)
}

export default shouldDeliverToRecipientGiftSelect
